import { useMemo } from 'react';

import { PerformanceChart } from 'components/redesignStudent';
import { useAppSelector } from 'hooks';
import { placeholderCharacter } from 'images';
import NoDataPlug from 'portfolio3/components/common/NoDataPlug';
import { learningYearFinalPerformanceSelector } from 'portfolio3/features/performance/model/selectors';

const PerformanceChartContainer = () => {
  const finalPerformance = useAppSelector(learningYearFinalPerformanceSelector);
  const performance = useMemo(() => {
    const filteredPerfomance = finalPerformance.content.filter((item) => item.averageGrade > 0);

    return [...filteredPerfomance].sort((a, b) => Number(a.year.split('-')[0]) - Number(b.year.split('-')[0]));
  }, [finalPerformance]);

  if (performance.length === 0) {
    return (
      <NoDataPlug
        image={placeholderCharacter}
        title="Данных по предметным результатам пока нет"
        subtitle="Как только они появятся, информация о них отобразится здесь"
      />
    );
  }

  return <PerformanceChart performance={performance} />;
};

export default PerformanceChartContainer;
